import { debounce } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { ReactNewWindowStyles } from "react-new-window-styles";
import { connect } from "../../../base/redux";
import { setVideoLayoutProperty } from "../../actions";
import { default as DualMonitorContainer } from "./DualMonitorContainer";

function DualMonitor({ dispatch, isDualMonitor }) {
    const newWindowNode = useRef();
    const [outerWidth, setOuterWidth] = useState(0);
    const [outerHeight, setOuterHeight] = useState(0);
    const [windowOpen, setWindowOpen] = useState(false);

    const setContainerStyle = (e) => {
        const { innerWidth, innerHeight } = e.target;
        
        setOuterWidth(innerWidth);
        setOuterHeight(innerHeight);
    }

    const unload = () => {
        dispatch(setVideoLayoutProperty({ isDualMonitor: false }));
        setWindowOpen(false);
    }

    const open = e => {
        e.addEventListener("resize", setContainerStyle);
    }

    useEffect(debounce(() => {
        if (isDualMonitor) {
            setWindowOpen(true);
        }
    }, [isDualMonitor], 1000));

    useEffect(() => {
        if (windowOpen && newWindowNode) {
            const element = newWindowNode.current.state.externalWindow;
            if (element && element.window) {
                element.window.addEventListener('resize', setContainerStyle);
            }
        } 
    }, [windowOpen]);

    const getChildren = () => {
        return (
            <ReactNewWindowStyles 
                ref={newWindowNode}
                title="Meemate2"
                windowProps={{width: '960px', height: '600px'}} 
                onClose={unload}
                copyStyles={true}
                autoClose={true}>
                <div style={{
                        width: "100%", height: "100%", 
                        display: "flex", justifyContent: "center", alignItems: "center"
                    }}
                >   
                    <DualMonitorContainer outerWidth={outerWidth} outerHeight={outerHeight}  />
                </div>
            </ReactNewWindowStyles>
        )
    }

    return (
        <>
            { isDualMonitor && (
                <> { getChildren() } </>
            )}  
        </>
    );
}

function _mapStateToProps(state) {
    const { isDualMonitor } = state["features/video-layout-mode"];
    
    return {
        isDualMonitor
    }
}

export default connect(_mapStateToProps)(DualMonitor);
